<template>
	<div>
		<j-expendable-box
			v-for="i in numberOfInsureds"
			:key="'Shipping' + i"
			class="mb2"
		>
			<div slot="header" class="xs-12 p4 fs4 fw7 bg5 r2 b1 bc7">Exhibition {{ i }}</div>
			<div slot="body" class="xs-12 p4 bg5 b1 bt0 bc7 r2">
				<case-form :schema="buildSchemaInsured(i - 1)" :isBoxed="false" />
			</div>
		</j-expendable-box>

		<!-- Add Button -->
		<j-button class="mt6" type="primary" @click="numberOfInsureds++">Add</j-button>
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"
import JButton from "@/components/JButton/"
import JExpendableBox from "@/components/JExpendableBox"

export default {
	name: "EXProposalInsureds",
	components: { CaseForm, JExpendableBox, JButton },

	data() {
		return {
			numberOfInsureds: this.$store?.state?.caseManagement?.case?.insureds
				?.length
				? this.$store.state.caseManagement.case.insureds.length
				: 1
		}
	},

	computed: {
		insureds() {
			return this.$store?.state?.caseManagement?.case?.insureds
		},

		schemaInsureds() {
			let schema = []
			for (let i = 0; i < this.numberOfInsureds; i++) {
				schema.push(...this.buildSchemaInsured(i))
			}
			return schema
		}
	},

	methods: {
		buildSchemaInsured(i) {
			return [
				{
					label: "Select Exhibition " + (i + 1),
					component: "entitySelect",
					bindTo: `case.insureds[${i}]`,
					entity: `case.insureds[${i}]`,
					props: {
						allowedEntityTypes: ["object"]
					}
				},
				{
					label: "From",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.fromDateInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "fromDate"
						},
						createOptions: {
							type: "fromDate",
							dataType: "date"
						}
					}
				},
				{
					label: "To",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.toDateInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "toDate"
						},
						createOptions: {
							type: "toDate",
							dataType: "date"
						}
					}
				},
				{
					label: "Location",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.locationInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "location"
						},
						createOptions: {
							type: "location",
							dataType: "string"
						}
					}
				},
				{
					label: "City",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.cityInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "city"
						},
						createOptions: {
							type: "city",
							dataType: "string"
						}
					}
				},
				{
					label: "Transit Service",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.transitServiceInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "transitService"
						},
						createOptions: {
							type: "transitService",
							dataType: "string",
							value: {
								component: "select",
								props: {
									options: [
										{ name: "As Per Attached", value: "option 1" },
										{
											name: "Personal Conveyance - Local",
											value: "Personal Conveyance - Local"
										},
										{
											name: "Personal Conveyance - Overseas",
											value: "Personal Conveyance - Overseas"
										},
										{
											name: "Professional Courrier - Local",
											value: "Professional Courrier - Local"
										},
										{
											name: "Professional Courrier - Overseas",
											value: "Professional Courrier - Overseas"
										}
									]
								}
							}
						}
					}
				},
				{
					label: "Event Description",
					component: "entityFact",
					entity: `case.insureds[${i}]`,
					relation: `case.insureds[${i}].facts`,
					bindTo: `case.facts.eventDescriptionInsured${i}Id`,
					props: {
						suggest: {
							typeIncludes: "eventDescription"
						},
						createOptions: {
							type: "eventDescription",
							dataType: "string"
						}
					}
				}
			]
		}
	},

	watch: {
		insureds: {
			handler() {
				this.numberOfInsureds = this.$store?.state?.caseManagement?.case
					?.insureds?.length
					? this.$store?.state?.caseManagement?.case?.insureds?.length
					: 1
			}
		}
	}
}
</script>
